"use client";

import { cn } from "@devhop/ui";
import { CheckIcon } from "lucide-react";
import type { WorkshopJobStatusDTO } from "../../domain/contracts";
import {
  WORKSHOP_STATUS_LABELS,
  WORKSHOP_STEPPER_STATUSES,
} from "../lib/workshop-labels";
import { WORKSHOP_STATUS_ICONS } from "./workshop-status-icons";

const ORDER: Record<WorkshopJobStatusDTO, number> = {
  received: 0,
  in_progress: 1,
  waiting_parts: 2,
  completed: 3,
  paid: 4,
  cancelled: -1,
};

export function WorkshopStatusStepper({
  status,
}: {
  status: WorkshopJobStatusDTO;
}) {
  if (status === "cancelled") {
    return (
      <p className="rounded-xl border border-border bg-muted/50 px-3 py-3 text-center text-muted-foreground text-sm">
        ໃບງານຖືກຍົກເລີກແລ້ວ
      </p>
    );
  }

  const current = ORDER[status];

  return (
    <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
      {WORKSHOP_STEPPER_STATUSES.map((s) => {
        const idx = ORDER[s];
        const done = idx < current;
        const now = idx === current;
        const StepIcon = WORKSHOP_STATUS_ICONS[s];
        return (
          <div
            key={s}
            className={cn(
              "flex min-h-17 min-w-20 flex-1 flex-col items-center justify-center gap-1.5 rounded-xl border px-2 py-2.5 text-center transition-colors",
              done &&
                "border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-500/35 dark:bg-emerald-500/10 dark:text-emerald-100",
              now &&
                "scale-[1.02] border-primary bg-primary/10 text-foreground shadow-sm ring-2 ring-primary/25",
              !done &&
                !now &&
                "border-border/70 bg-muted/30 text-muted-foreground",
            )}
          >
            <span
              className={cn(
                "flex size-8 items-center justify-center rounded-full font-semibold text-xs",
                done && "bg-emerald-600 text-white dark:bg-emerald-500",
                now && "bg-primary text-primary-foreground",
                !done && !now && "bg-muted text-muted-foreground",
              )}
            >
              {done ? (
                <CheckIcon className="size-4" aria-hidden />
              ) : (
                <StepIcon className="size-4" aria-hidden />
              )}
            </span>
            <span className="font-semibold text-[11px] leading-tight">
              {WORKSHOP_STATUS_LABELS[s]}
            </span>
          </div>
        );
      })}
    </div>
  );
}
